import { Status } from '@essent/common';
import { getSelectedSupplyAddressId } from '@supply-address/store';
import { createSelector } from '@ngrx/store';

import { getRetentionState } from '../retention-feature.selector';
import { unknownValue } from './flow-id.reducer';

export const getFlowIdState = createSelector(
  getRetentionState,
  (state) => state.flowId
);

export const getFlowIdEntry = createSelector(
  getFlowIdState,
  getSelectedSupplyAddressId,
  (state, selectedSupplyAddressId) =>
    state.entities[selectedSupplyAddressId || unknownValue]
);

export const getFlowIdStatus = createSelector(
  getFlowIdEntry,
  (entry) => entry?.status
);

export const getFlowIdHasError = createSelector(
  getFlowIdStatus,
  (status) => status === Status.ERROR
);

export const isFlowIdLoading = createSelector(
  getFlowIdStatus,
  getFlowIdHasError,
  (status, hasError) =>
    (status === undefined ||
      status === Status.PENDING ||
      status === Status.IDLE) &&
    !hasError
);

export const getFlowId = createSelector(
  getFlowIdEntry,
  (entry) => entry?.entry
);

export const getFlowIdString = createSelector(
  getFlowId,
  (entry) => entry?.flowId
);
